import React, { useState, useEffect } from "react";
import axios from "axios";
import { InView } from "react-intersection-observer";

const TrendsList = ({ lazyLoadOptions }) => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(lazyLoadOptions.page + 1 || 2); // SSR the first page, CSR after the second page. Attach contents at the bottom of the page, instead of making another page.

  useEffect(() => {
    if (data.length === 0) fetchData();
  }, [data]);

  const fetchData = async () => {
    try {
      const response = await axios.get("/api/v2/series/trends", {
        params: {
          page: page,
          itemsperpage: lazyLoadOptions.itemsperpage || 12
        }
      });

      setData((prevData) => [...prevData, ...response.data]);
      setPage((prevPage) => prevPage + 1);
    } catch (e) {
      // No actions need to be taken on client side
    }
  };

  const onChange = async (inView) => {
    if (inView) await fetchData();
  };

  const LastTrendsSummary = (htmlString = "", key) => (
    <InView
      key={key}
      rootMargin="200px 0px"
      triggerOnce={true}
      onChange={onChange}
      className="TrendsSummary"
      dangerouslySetInnerHTML={{ __html: htmlString }}
    />
  );

  const TrendsSummary = (htmlString = "", key) => (
    <div key={key} className="TrendsSummary" dangerouslySetInnerHTML={{ __html: htmlString }} />
  );

  const renderTrendsSummaries = data.map((htmlString, key) => {
    const isLast = key === data.length - 1;
    if (isLast) return LastTrendsSummary(htmlString, key);
    else return TrendsSummary(htmlString, key);
  });

  return <>{renderTrendsSummaries}</>;
};

export default TrendsList;
